import { render, staticRenderFns } from "./DownloadThumbnail.vue?vue&type=template&id=4ed535da&scoped=true&"
import script from "./DownloadThumbnail.vue?vue&type=script&lang=ts&"
export * from "./DownloadThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadThumbnail.vue?vue&type=style&index=0&id=4ed535da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed535da",
  null
  
)

export default component.exports